/*
 * @Author: your name
 * @Date: 2022-01-14 11:53:39
 * @LastEditTime: 2022-03-01 20:38:31
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /weichao_im/src/utils/config.js
 */
/**
 *  项目的配置文件
 */

export const apiUrl = 'https://srm.tinytide.cn/'//接口请求地址
export const chatUrl = 'wss://im.tinytide.cn'//客服地址
export const storeUrl = 'https://srm.tinytide.cn/'//接口请求地址
export const curLang = 'zh';//当前语言,zh:中文，若为其他语言，需要对应/src/assets/language下面的文件名

/** copyright *** slodon *** version-v3.2 *** date-2021-11-18 ***主版本v3.5**/


